userInfo.$inject = ['adminApi', 'analyticsApi']

export default function userInfo(adminApi, analyticsApi) {
  var service = {
    UI: {
      loading: false,
      showError: false,
      errorMessage: null,
      errorTitle: null
    },
    userInfo: null
  }

  function errorFunc(reason) {
    this.UI.showError = true
    this.UI.errorMessage = reason.message
    this.UI.errorTitle = 'Error fetching user ' + (email || uuid)
    this.UI.loading = false
    this.userInfo = null
  }

  service.refreshUser = async function(email, uuid) {
    try {
      // do init for a given email address
      this.UI.loading = true
      this.userInfo = await adminApi.getUserInfo(email || '', uuid || '')
      this.UI.loading = false
      this.UI.showError = false
    } catch (err) {
      errorFunc.bind(this)(err)
      return
    }

    await service.refreshUserDevices()
    await service.refreshContentAccessReport()
  }

  service.refreshUserDevices = async function() {
    if (!this.userInfo || !this.userInfo.user_graph || !this.userInfo.user_graph.uuid) {
      return
    }
    try {
      // For user devices, sdate and edate don't matter
      // but required for getReport API
      var sDate = '0001-01-01'
      var eDate = '2100-01-01'
      const userDeviceReport = await analyticsApi.getUserReport(
        'user_devices',
        this.userInfo.user_graph.uuid,
        sDate,
        eDate,
        'mongo'
      )
      this.userInfo.user_device_report = userDeviceReport[0].Report
    } catch (err) {
      errorFunc.bind(this)(err)
    }
  }

  service.refreshContentAccessReport = async function() {
    try {
      this.userInfo.content_access_report = await analyticsApi.getUserContentAccessReport(
        this.userInfo.user_graph.uuid
      )
    } catch (err) {
      errorFunc.bind(this)(err)
    }
  }

  return service
}
